<template>
    <div
        id="be-watermark"
        class="bg-light"
    >
        <div class="body-wrapper">
            <backend-header />
            <main>
                <div class="barra-titolo-azioni bg-white border-bottom py-2">
                    <b-container fluid>
                        <div class="row d-flex justify-content-between flex-wrap align-items-center">
                            <div class="col-sm-7 d-flex justify-content-start align-items-center">
                                <!--
                                <div class="navbar-nav pulsante-indietro">
                                <a title="Indietro" class="pulsante-indietro" @click="goToGalleries">
                                    <font-awesome-icon :icon="['fas', 'arrow-left']"/>
                                </a>
                                </div>-->
                                <div>
                                    <h1 class="mb-0 text-blurikorda">
                                        <span class="titolo">
                                            {{ $t('Watermark') }}
                                        </span>
                                        &nbsp;
                                    </h1>
                                </div>
                            </div>
                            <div class="col-sm-5 mt-3 mt-sm-0">
                                <ul class="d-sm-flex justify-content-end flex-wrap mb-0">
                                    <li class="d-inline-block">
                                        <b-button
                                            variant="primary"
                                            class="btn-rikorda1"
                                            @click="saveWatermark"
                                            :disabled="saving"
                                        >
                                            {{ saving ? $t("Salvataggio") : $t("Salva") }}
                                        </b-button>
                                    </li>
                                    <li class="d-inline-block ml-2">

                                    </li>
                                </ul>
                            </div>
                        </div>
                    </b-container>
                </div>

                <backend-watermark-editor
                    ref="watermarkEditor"
                    v-if="idWatermark"
                    :idWatermark="idWatermark"
                />

            </main>
            <backend-footer />
        </div>
    </div>
</template>

<script>
import BackendHeader from "../../components/backend/Header";
import BackendFooter from "../../components/backend/Footer";
import BackendWatermarkEditor from "../../components/backend/WatermarkEditor";

export default {
    name: "BackendWatermark",

    components: {
        BackendHeader,
        BackendFooter,
        BackendWatermarkEditor
    },

    data() {
        return {
            saving: false,
            idWatermark: "",
            watermark: {}
        };
    },

    mounted() {
        if (this.$store.getters.isAgent) {
            this.$router.push({
                name: "backend-dashboard"
            });
            return;
        }
        this.idWatermark = this.$route.params.idWatermark;
    },

    methods: {
        saveWatermark() {
            this.saving = true;
            this.$refs.watermarkEditor.saveWatermark().finally(() => {
                this.saving = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
